import { MouseEvent, useState } from "react";
import { Edit2, Trash2 } from "react-feather";
import { useTheme } from "styled-components";
import { Button } from "styles/Button";
import { SupportAgent } from "types/SupportAgent";
import { useDeleteSupportAgent } from "hooks/mutations/useDeleteSupportAgent";
import { useEditSupportAgent } from "hooks/mutations/useEditSupportAgent";
import { EditSupportAgentModal } from "components/EditSupportAgentModal";
import { ActionsButtons } from "components/ManageMacroModal/styles";
import Swal from "sweetalert2";
import Switch from "react-switch";

type Props = {
  agent: SupportAgent;
};

export function SupportAgentCard({ agent }: Props) {
  const theme = useTheme();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const deleteAgent = useDeleteSupportAgent();
  const editAgent = useEditSupportAgent();

  async function handleToggleAvailability() {
    await editAgent.mutateAsync({
      agent,
      data: { is_available: !agent.is_available },
    });
  }

  async function handleDelete(e: MouseEvent) {
    e.stopPropagation();

    const result = await Swal.fire({
      title: 'Remover do rodízio?',
      text: `Tem certeza que deseja remover ${agent.user?.name} do rodízio de suporte?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Remover',
      confirmButtonColor: theme.colors.danger,
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;
    await deleteAgent.mutateAsync(agent);
  }

  return (
    <>
      <tr>
        <td>{agent.user?.name ?? '—'}</td>
        <td>{agent.user?.email ?? '—'}</td>
        <td>
          <Switch
            checked={agent.is_available}
            onChange={handleToggleAvailability}
            onColor={theme.colors.primary}
            offColor={theme.colors.border}
            height={20}
            width={42}
            handleDiameter={16}
            uncheckedIcon={false}
            checkedIcon={false}
          />
        </td>
        <td>{agent.weight}</td>
        <td>{agent.current_weight}</td>
        <td>
          <ActionsButtons>
            <Button small onClick={(e) => { e.stopPropagation(); setIsEditModalOpen(true); }}>
              <Edit2 color={theme.colors.buttonText} size="16" />
            </Button>
            <Button small onClick={handleDelete}>
              <Trash2 color={theme.colors.buttonText} size="16" />
            </Button>
          </ActionsButtons>
        </td>
      </tr>

      <EditSupportAgentModal
        isOpen={isEditModalOpen}
        onRequestClose={() => setIsEditModalOpen(false)}
        agent={agent}
      />
    </>
  );
}
